import { SummaryViewResponseAPI } from '@/types/summaryView';

export const FETCH_ORG_SUMMARY_VIEW_SUCCESS = 'FETCH_ORG_SUMMARY_VIEW_SUCCESS';

export interface OrgSummaryViewResponse {
    requestId: string;
    scopeKey: string;
    rowSetSignature: string;
    fetchedProperties: string[];
    summaryView: SummaryViewResponseAPI;
}

export const createSummaryViewScopeKey = ({
    requestId,
    destinationIds,
    versions,
    offset,
    limit,
}: {
    requestId: string;
    destinationIds: string[];
    versions?: string[];
    offset?: number;
    limit?: number;
}) =>
    JSON.stringify({
        requestId,
        destinationIds,
        ...(versions ? { versions } : {}),
        offset: offset ?? 0,
        limit: limit ?? 0,
    });

export interface FetchOrgSummaryViewSuccessAction {
    type: typeof FETCH_ORG_SUMMARY_VIEW_SUCCESS;
    payload: OrgSummaryViewResponse;
}

export const fetchOrgSummaryViewSuccess: (payload: OrgSummaryViewResponse) => FetchOrgSummaryViewSuccessAction = (
    payload,
) => {
    return {
        type: FETCH_ORG_SUMMARY_VIEW_SUCCESS,
        payload,
    };
};
